'use strict';
angular.module("logManageMentOnlineUsersRouterModule", [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.
        state("manageconfig.logmanage.onlineusers", {
            url: '/onlineusers',
            views: {
                'main@manageconfig.logmanage': {
                    templateUrl: './manageConfig/logManageMent/onlineUsers/onlineUsers_tpl.html',
                    controller: 'logManageMentonlineUsersCtrl',
                },
                'footer@manageconfig.logmanage': {
                    templateUrl: './footer_tpl.html'
                }
            }
        });
    }]);
